export const activities = [
  { key: 'indoors', name: 'Indoors' },
  { key: 'indoorsOthersFaceCovered', name: 'Indoors (others face covered)' },
  { key: 'outdoors', name: 'Outdoors' },
  { key: 'outdoors2MeterDistancing', name: 'Outdoors (2+ metres distancing)' }
]
